<template>
  <div class="ConfGallery" :class="{ 'ConfGallery-inline': inline }">
    <template v-for="(img, index) of imgs">
      <img v-if="img && index < 4" :key="index" :src="img.thumbnail" @click="() => showImg(index)">
    </template>
    <div class="ConfGallery-count" v-if="imgs.length > 4 && !inline" @click="() => showImg(4)">+{{ imgs.length - 4 }}
    </div>
    <vue-easy-lightbox :visible="visible" :imgs="imgs" :index="index" @hide="handleHide"
                       @on-index-change="handleChange">
      <template v-slot:close-btn="{ close }">
        <div class="count__holder">{{ index + 1 }} / {{ imgs.length }}</div>
        <div class="btn__close" @click="close">
          <svg class="vel-icon icon" aria-hidden="true">
            <use xlink:href="#icon-close"></use>
          </svg>
        </div>
      </template>
    </vue-easy-lightbox>
  </div>
</template>

<script>
import {reactive, toRefs} from 'vue';

export default {
  props: {
    image: Object,
    images: {
      type: Array,
      default: []
    },
    inline: Boolean
  },
  setup(props) {
    const state = reactive({
      visible: false,
      index: 0,
      imgs: [props.image, ...props.images].filter(img => !!img)
    });

    const showImg = (index) => {
      state.index = index
      state.visible = true
    }

    const handleHide = () => {
      state.visible = false
    }

    const handleChange = (oldIndex, newIndex) => {
      state.index = newIndex;
    }

    return {
      ...toRefs(state),
      showImg,
      handleHide,
      handleChange
    }
  }
}
</script>

<style lang="scss" scoped>
.ConfGallery {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  img {
    max-width: 100%;
    width: calc((100% - 16px) / 3);
    cursor: pointer;
    transition: .4s ease-in-out;

    &:hover {
      opacity: .8;
    }
  }

  &:not(&-inline) img:first-child {
    width: 100%;
  }

  &-inline {
    gap: 4px;

    img {
      width: calc((100% - 12px) / 4);
    }
  }

  &-count {
    position: absolute;
    right: -.5rem;
    bottom: -.5rem;
    padding: .25em .5em;
    background: var(--colorBrandDarken);
    color: #fff;
    font-size: 1.5em;
    font-weight: 700;
    cursor: pointer;
    transition: .4s ease-in-out;

    @media (max-width: 640px) {
      font-size: 1.25em;
    }

    &:hover {
      background: var(--colorBrand);
    }
  }

  .ConfEntry-field & {
    margin-top: .5em;
  }
}

.count__holder {
  position: absolute;
  top: 12px;
  left: 16px;
  font-size: 20px;
  color: #fff;
}
</style>